import React, { FC, Fragment } from "react";
import { Divider, Popover } from "@mui/material";
import { CompaniesBasicsListItemDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { PopoverContent } from "./CompanySelectPopover.styled";

import { useGetAssignedCompanies } from "@api";
import { Box, Button, Typography } from "@components/base";

interface CompanySelectPopover {
  open: boolean;
  anchorEl: HTMLButtonElement | null;

  onClose(): void;

  onSelectCompany: (company: CompaniesBasicsListItemDto) => void;
}

const CompanySelectPopover: FC<CompanySelectPopover> = ({
  open,
  anchorEl,
  onClose,
  onSelectCompany,
}) => {
  const { t } = useTranslation();
  const { assignedCompanies } = useGetAssignedCompanies();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        horizontal: 0,
        vertical: -10,
      }}
      slotProps={{
        paper: {
          sx: (theme) => ({
            background: theme.palette.main[800],
          }),
        },
      }}
    >
      <PopoverContent width={248}>
        {/* TODO: use enum */}
        {Array.from({ length: 6 })?.map((_, companyType) => {
          const companies = assignedCompanies?.filter(
            (c) => c.companyType === companyType,
          );

          return companies && companies.length > 0 ? (
            <Fragment key={`company-type-${companyType}`}>
              <Typography variant="subtitle2">
                {t(`companyType.${companyType}`)}
              </Typography>
              {companies?.map((company) => (
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => onSelectCompany(company)}
                  key={company.id}
                >
                  {company.name}
                </Button>
              ))}
              {companyType < companies.length - 1 ? (
                <Divider />
              ) : (
                <Box padding={1} />
              )}
            </Fragment>
          ) : null;
        })}
      </PopoverContent>
    </Popover>
  );
};

export default CompanySelectPopover;
